module.exports = __webpack_public_path__ + "media/components/breakheader/background/background--7-23570ede034541155092aaac41cb5110.jpg";